export default "__VITE_ASSET__45cd5717__"